import { useFormikContext } from "formik";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalidades } from "../../../../redux/actions/direccion";
import FormikAutocomplete from "../FormikAutocomplete";


const FormikLocalidad = ({ nameLocationFields, label }) => {
    const dispatch = useDispatch();

    const localidades = useSelector((state) => state.direccion.localidades);
    const localidadesMemorizadas = useMemo(() => localidades.data.map((localidad) => ({
        nombre: localidad.nombre.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
            letter.toUpperCase()),
        id: localidad.id.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
            letter.toUpperCase())
    })), [localidades])
    const { values, setFieldValue } = useFormikContext();

    return (
        <>
            <FormikAutocomplete
                name={nameLocationFields.localidad}
                label={label ? label : "Localidad *"}
                options={localidadesMemorizadas}
                disabled={!values?.[nameLocationFields.provincia]}
                renderOption={(option) => option.nombre}
                filterOptions={(option) => option.nombre}
                fullWidth
                callBack={(value) => {
                    if (!value) {
                        setFieldValue(nameLocationFields.calle, "");
                        setFieldValue(nameLocationFields.numero, "");
                        setFieldValue(nameLocationFields.codigoPostal, "");
                    }
                }}
                getOptions={() =>
                    dispatch(getLocalidades(values?.[nameLocationFields.provincia]))
                }
            />
        </>
    );
}

export default FormikLocalidad;
